export default __webpack_public_path__ + "static/media/DRYCOOL.ddf7580b.pdf";